export const countSyllables = lineText =>
  (lineText || '').split(/[- ]/).filter(syl => syl.trim().length).length;



// WEBPACK FOOTER //
// ./src/utils/text.js